import {
	Component,
	EventEmitter,
	Output,
	ElementRef,
	Input,
	OnInit,
	ChangeDetectionStrategy,
	ViewEncapsulation,
} from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
	selector: 'fn-grid-search',
	templateUrl: 'fn-grid.search.component.html',
	styleUrls: ['fn-grid.search.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class FnGridSearchComponent implements OnInit {
	public debouncer: Subject<string> = new Subject();
	@Output() search = new EventEmitter<string>();
	@Output() closeSearch = new EventEmitter<string>();
	@Input() config: { actionClear: Subject<any> };

	constructor(private el: ElementRef) {
		this.debouncer.pipe(debounceTime(200)).subscribe((val) => {
			this.search.emit(val);
		});
	}

	ngOnInit(): void {
		this.config.actionClear.subscribe((val) => {
			if (val) {
				this.clear();
			}
			this.el.nativeElement.lastChild.value = '';
		});
	}

	debounce(value: string) {
		this.debouncer.next(value);
	}

	private clear() {
		const ele: any = document.getElementById('fn-grid-serch-i');
		if(ele) {
			ele.value = '';
		}
	}

	handleClose() {
		this.closeSearch.emit('true');
		this.clear();
	}
}
